import axios from "axios";
import { setHeaders } from './set-headers';
import { buildResponse ,buildPostResponse} from './build-response';
import { handleErrors } from './handle-errors';
import {notification} from "antd";

class Axios {

    async get(url) {
        try {
            var config = {
                method: 'get',
                url: url,
                headers: setHeaders()
            };

            return await axios(config)
                .then((response) => {
                    if (response.status === 200 ||response.status === 201) {
                      
                        return buildResponse(response);
                    } else {
                        return handleErrors(response);
                    }
                })
                .catch((error) => {
                    // console.log(error)
                    if (error.response.status === 401) {

                        window.location.replace("/login");
                        localStorage.setItem("token","")
                        return handleErrors(error);
                    }else{
                        return handleErrors(error);
                    }
                
                });

        } catch (error) {
            return handleErrors(error);
        }
    }

    async post(type = "", url, data) {

        try {
            var config = {
                method: 'post',
                url: url,
                data: data,
                headers: setHeaders()
            };
            return await axios(config)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        return buildPostResponse(response);
                    } else {
                        // console.log("ERROR4", response)
                        return handleErrors(response, response.message);
                    }
                })
                .catch(async(error) => {
                    // if (error.response.status === 409){
                    //     console.log(error.response.data.message);
                    //     notification.error({
                    //         message: "اخطار",
                    //         description: error.response.data.message,
                    //         placement: "topRight"
                    //     });
                        // openNotificationWithIcon("error", "error.response.data.message", "خطار");
                        // notification.open({
                        //     message: "اخطار",
                        //     description: "error.response.data.message",
                        //     style: {
                        //         background: "#43a047",
                        //         color: "white",
                        //         fontFamily: "IRANSansMobileFaNum",
                        //         borderRadius: "5px",
                        //     }
                        // })

                    return handleErrors(error.response.data.errors, error.response.data.message);

                });

        } catch (error) {
            // console.log("ERROR!!", error)
            return handleErrors(error);
        }
    }

    async put(url, data) {
        try {

            var config = {
                method: 'put',
                url: url,
                data: data,
                headers: setHeaders()
            };

            return await axios(config)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        return buildResponse(response);
                    } else {
                        // console.log("putERRO1", response)
                        return handleErrors(response, response.message);;
                    }
                })
                .catch((error) => {
                    // console.log("putERROR2", error)
                    return handleErrors(error.response.data.errors, error.response.data.message);
                });

        } catch (error) {
            // console.log("putError3", error)
            return handleErrors(error);
        }
    }

    async patch(url, data) {
        try {

            var config = {
                method: 'patch',
                url: url,
                data: data,
                headers: setHeaders()
            };

            return await axios(config)
                .then((response) => {
                    return buildResponse(response);
                })
                .catch((error) => {
                    return handleErrors(error);
                });

        } catch (error) {
            return handleErrors(error);
        }
    }

    async delete(url, data) {
        try {

            var config = {
                method: 'delete',
                url: url,
                data: data,
                headers: setHeaders()
            };

            return await axios(config)
                .then((response) => {
                    return buildResponse(response);
                })
                .catch((error) => {
                    return handleErrors(error);
                });

        } catch (error) {
            return handleErrors(error);
        }
    }

}

export default new Axios();